import React from "react";
import { X, CheckCircle, Clock, MapPin, Money, CreditCard } from "@phosphor-icons/react";

export function IncomingRequestModal({ incoming, reqLeft, onAccept, onReject }) {
  const isCard = incoming.payment_method === "card";
  return (
    <div className="absolute inset-0 z-[1100] bg-slate-900/60 flex items-end sm:items-center justify-center p-4" data-testid="incoming-request-modal">
      <div className="bg-white rounded-3xl p-6 w-full max-w-md slide-up">
        <div className="flex items-center justify-between mb-4">
          <span className="pill pill-warn">Nueva solicitud</span>
          <div className="text-3xl font-display font-bold" style={{ color: "var(--primary)" }} data-testid="incoming-countdown">{reqLeft}s</div>
        </div>
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="text-xs text-slate-500">Pasajero</div>
            <div className="font-bold text-lg">{incoming.passenger_name}</div>
          </div>
          <span className="font-display font-bold text-2xl" style={{ color: "var(--primary)" }}>€{incoming.estimated_price?.toFixed(2)}</span>
        </div>
        <div className="space-y-2 mb-4 text-sm">
          <div className="flex gap-2 items-start"><div className="w-3 h-3 mt-1 rounded-full bg-emerald-500" /> <span>{incoming.pickup_address}</span></div>
          <div className="flex gap-2 items-start"><div className="w-3 h-3 mt-1 rounded-full bg-red-500" /> <span>{incoming.dest_address}</span></div>
        </div>
        <div className="flex items-center gap-3 mb-5 text-sm text-slate-600">
          {incoming.eta_to_pickup != null && <span className="flex items-center gap-1"><Clock size={15} weight="duotone" />{incoming.eta_to_pickup} min al pasajero</span>}
          {incoming.distance_km != null && <span className="flex items-center gap-1"><MapPin size={15} weight="duotone" />{incoming.distance_km} km viaje</span>}
        </div>
        <div className="rounded-xl px-4 py-3 mb-5 flex items-center gap-2 font-bold" style={{ background: "var(--primary-soft)" }} data-testid="incoming-payment-method">
          {isCard ? <CreditCard size={20} weight="duotone" /> : <Money size={20} weight="duotone" />}
          <span>Cobrar en {isCard ? "TARJETA" : "EFECTIVO"}</span>
        </div>
        <div className="flex gap-3">
          <button onClick={onReject} className="btn-ghost flex-1 text-red-600 font-bold" data-testid="reject-ride-btn">
            <X size={18} className="inline mr-1" weight="bold" /> Rechazar
          </button>
          <button onClick={onAccept} className="btn-primary flex-1" data-testid="accept-ride-btn">
            <CheckCircle size={18} className="inline mr-1" weight="fill" /> Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
